import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { ExternalUserFormInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-form.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { MailingChannelEnum } from '@zaoblako/shared/modules/notification/enums/mailing.channel.enum';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { BasisClientService } from '@zaoblako/web/core/services/basis/basis-client.service';
import { DashboardService } from '@zaoblako/web/core/services/dashboard/dashboard.service';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import moment from 'moment-timezone';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'crm-newsletter-welcome-system-create-contacts',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    ButtonComponent,
    TableComponent,
    InputTextComponent,
    InputMaskModule,
    FormsModule,
    JoinPipe
  ],
  templateUrl: './newsletter-welcome-system-create-contacts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemCreateContactsComponent implements OnInit {
  public loading = true;
  public contragents: ContragentFindInterface[] = [];
  @Input() public channel: MailingChannelEnum;
  public contacts: ExternalUserFormInterface[] = [];

  public columns: CrmTableColumn[] = [
    {
      label: 'Контрагент',
      name: 'contragent',
      sort: 'contragent.name:string'
    },
    { label: 'Имя' },
    { label: 'Номер' }
  ];

  public error: string[] = [];

  @Output() public next = new EventEmitter<ContragentFindInterface[]>();

  public get MailingChannelEnum() {
    return MailingChannelEnum;
  }

  public constructor(
    private readonly dashboardService: DashboardService,
    private readonly basisClientService: BasisClientService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.dashboardService
      .getDebtors({
        date: moment().format('YYYY-MM-DD') as unknown as Date,
        onlyPositive: true
      })
      .subscribe((result) => {
        this.contragents = result.items
          ?.map((item) => item.contragent)
          .filter((contragent) => contragent?.id && !contragent?.externalUsers?.length);
        this.contragents.forEach((contragent) => {
          const contact = <ExternalUserFormInterface>{};
          contact.client = contragent?.client;
          contact.isMailingEnabled = true;
          this.contacts.push(contact);
        });
        this.loading = false;
        this.cdRef.markForCheck();
      });

    if (this.channel === MailingChannelEnum.SMS) {
      this.columns[2] = { label: 'Номер' };
    } else {
      this.columns[2] = { label: 'Email' };
    }
  }

  public toContact(contact: any): ExternalUserFormInterface {
    return contact as ExternalUserFormInterface;
  }

  public nextClick() {
    this.error = [];
    // this.contacts.forEach((contact) => {
    //   if (contact.phone?.length && contact.phone?.[0] && contact.phone[0] !== '+') {
    //     contact.phone = '+' + contact.phone;
    //   }
    //   if (
    //     !contact.name?.length &&
    //     ((this.channel === MailingChannelEnum.EMAIL && !contact.email?.length) ||
    //       (this.channel === MailingChannelEnum.SMS && !contact.phone?.length))
    //   ) {
    //     this.error.push(`${contact.contragent?.name}: Ничего не заполнено`);
    //   } else if (!contact.name?.length) {
    //     this.error.push(`${contact.contragent?.name}: Не заполнено имя`);
    //   } else if (
    //     (this.channel === MailingChannelEnum.EMAIL && !contact.email?.length) ||
    //     (this.channel === MailingChannelEnum.SMS && !contact.phone?.length)
    //   ) {
    //     this.error.push(
    //       `${contact.client?.name}: Не заполнен ${this.channel === MailingChannelEnum.SMS ? 'Номер' : 'Email'}`
    //     );
    //   }
    // });

    if (this.error?.length) {
      return;
    }

    this.loading = true;
    this.cdRef.markForCheck();

    this.basisClientService.contactPersonCreate(this.contacts).subscribe({
      next: () => {
        this.dashboardService
          .getDebtors({
            date: moment().format('YYYY-MM-DD') as unknown as Date,
            onlyPositive: true
          })
          .subscribe({
            next: (data) => {
              this.loading = false;
              this.cdRef.markForCheck();
              this.next.emit(data.items.map((item) => item.contragent).filter((contragent) => contragent?.id));
            }
          });
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
